import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Button,
  Card,
  CardContent,
  Grid2,
  IconButton,
  Typography,
  Box,
  Avatar,
  TablePagination,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import moment from "moment";
import MaterialButton from "../../../components/MaterialButton";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { Doughnut } from "react-chartjs-2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import MiniCard from "../MiniCard";
import { useDispatch, useSelector } from "react-redux";
import {
  checkIn,
  checkOut,
  setcheckInTime,
  setcheckOutTime
} from "../../../Redux/reducers/timerSlice";

ChartJS.register(ArcElement, Tooltip, Legend);
const HRdashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isCheckedIn, checkInTime, checkOutTime } =
    useSelector((state) => state.timer);
  const datas = sessionStorage.getItem("user");

  const parsedData = JSON.parse(datas); // Convert the string to an object

  const [displayTime, setDisplayTime] = useState("00:00:00");
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);
  const baseSecondsRef = useRef(0);
  const [ischeckIn,setisCheckIn] = useState(false)
  

  const [birthpopup, setBirthdayPopup] = useState(false);
  const [employeeLeave, setEmployeeLeave] = useState([]);
  const [dor, setDor] = useState([]);
  const [employeCount, setEmployeCount] = useState("");
  const [birthday, setbirthday] = useState([]);
  const [dates, setData] = useState({});
  const [count, setCount] = useState([]);
  const [leaveCount, setLeaveCount] = useState([]);
  const [depart, setdepart] = useState({
    value: [],
    label: [],
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [attendanceData, setAttendanceData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    getleave();
    fetchEmployeeDor();
    handeldatas();
    leavecount();
    fetchAttendanceData();
    handleCheck();
  }, []);

  //checkin checkout logic useffect
  useEffect(() => {
    handleCheck(); // on mount

    return () => stopTimer(); // cleanup
  }, []);

  useEffect(() => {
    handleCheck(); // initial load
    const syncInterval = setInterval(handleCheck, 5 * 60 * 1000); // 5 min
    return () => clearInterval(syncInterval);
  }, []);

  useEffect(() => {
    window.addEventListener("online", handleCheck);
    return () => {
      window.removeEventListener("online", handleCheck);
    };
  }, []);

  //checkin checkout logic end useffect

  const handleAddEmployee = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to clock out?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        // onEmployeeeSubmit();
        handleCheckIn();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const [totalLeaveCount, settotalLeaveCount] = useState(0);

  const getleave = async () => {
    let query = `query leavedetailbyme($id:String!){
      leaveDetailsByMe(id: $id){
        user{
          email
        }
        status
        takedLeave
        leaveType {
          id
          name
        }
        leaveCount
        workFromHome
      }
    }`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.leaveDetailsByMe;

      let filterdata = result.filter(
        (item) =>
          item?.leaveType?.name !== "loss_of_pay" &&
          item?.leaveType?.name !== "paternity_leave" &&
          item?.leaveType?.name !== "maternity_leave" &&
          item?.leaveType?.name !== "work_from_home"
      );

      let totalLeaveCounts = filterdata.reduce((acc, val) => {
        return acc + (val.leaveCount || 0); // Assuming 'leaveCount' is a property in the data
      }, 0);

      let totaltakedLeaveCounts = filterdata.reduce((acc, val) => {
        return acc + (val.takedLeave || 0); // Assuming 'leaveCount' is a property in the data
      }, 0);

      let finalresult = totalLeaveCounts - totaltakedLeaveCounts;

      settotalLeaveCount(finalresult);
    } catch (error) {
      console.error("errorssss:", error.message);
    }
  };

  //checkin checkout logic and functions
  const handleCheckIn = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);

    const queryCheckIn = `mutation CheckIn($id: String!) {
  checkInUpdate(id: $id) {
    success
    message
    error
    set
    checkin {
      id
      user {
        id
        firstName
        lastName
      }
      checkIn
      checkOut
      totalWorkingHours
      overtime
    }
  }
}`;
    const queryCheckOut = `mutation CheckOut($id: String!) {
  checkOutTime(id: $id) {
    success
    message
    error
    set
    checkout {
      id
      user {
        id
        firstName
        lastName
      }
      checkIn
      checkOut
      totalWorkingHours
      overtime
    }
  }
}`;

    if (ischeckIn) {
      // Clock-Out logic
      try {
        const response = await axios.post(BASEURL, {
          query: queryCheckOut,
          variables: { id: parsedData?.id }, // Ensure `id` is valid and exists
        });

        console.log("Check-Out Response:", response.data);

        if (response.data.errors) {
          Swal.fire({
            title: response.data.errors[0].message,
            showConfirmButton: true,
            timer: 2500,
          });
          console.error("Check-Out Error:", response.data.errors[0].message);
          return; // Exit if there's a server-side error
        }
        // setIsCheckedIn(false);
        setisCheckIn(false)
        dispatch(checkOut());
        dispatch(setcheckOutTime(data?.checkOut));
      } catch (error) {
        console.error("Error during Check-Out:", error.message);
      }
    } else {
      // Clock-In logic
      try {
        const response = await axios.post(BASEURL, {
          query: queryCheckIn,
          variables: { id: parsedData?.id }, // Ensure `id` is valid and exists
        });

        if (response.data.errors) {
          Swal.fire({
            title: response.data.errors[0].message,
            fontSize: "3em",
          });
          console.error("Check-In Error:", response.data.errors[0].message);
          return; // Exit if there's a server-side error
        }
        dispatch(checkIn());
        dispatch(
          setcheckInTime(response?.data?.data?.checkInUpdate?.checkin?.checkIn)
        );
        handleCheck(true);
      } catch (error) {
        console.error("Error during Check-In:", error.message);
      }
    }
  };

  const handleCheck = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);

    const queryCheckIn = `
    query GetLatestBiometricAttendance($userId: ID!) {
      latestBiometricAttendanceByUser(userId: $userId) {
        id
        checkIn
        checkOut
        totalWorkingHours
        overtime
        resumeTime
      }
    }
  `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: queryCheckIn,
          variables: { userId: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data?.latestBiometricAttendanceByUser;

      if (data && data.checkOut === null) {
        const resumeSeconds = parseTimeToSeconds(data.resumeTime || "00:00:00");

        // Save base resume seconds and start time (in ms)
        baseSecondsRef.current = resumeSeconds;
        startTimeRef.current = Date.now();
setisCheckIn(true)
        startAccurateTimer();
      } else {
        stopTimer();
        setDisplayTime("00:00:00");
        setisCheckIn(false)
      }
    } catch (error) {
      console.error("Error during Check-In:", error.message);
    }
  };

  const parseTimeToSeconds = (timeStr) => {
    const [h, m, s] = timeStr.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  // Format seconds → "HH:MM:SS"
  const formatTime = (seconds) => {
    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const startAccurateTimer = () => {
    stopTimer();
    intervalRef.current = setInterval(() => {
      const now = Date.now();
      const elapsed = Math.floor((now - startTimeRef.current) / 1000);
      const total = baseSecondsRef.current + elapsed;
      setDisplayTime(formatTime(total));
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(intervalRef.current);
  };
  //checkin checkout logic end

  const fetchEmployeeDor = async () => {
    const query = `
        query GetEmployeeLeaveDashboard { 
            employeeLeaveDashboard { 
                employeeName 
                leaveStartDate 
                leaveEndDate 
                primaryDelegate 
                secondaryDelegate 
                delegateEmployeeName 
                assignedTasks 
            } 
        }`;

    try {
      const response = await axios.post(
        BASEURL,
        { query },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = response.data.data?.employeeLeaveDashboard || [];

      const mappedData = data.map((item) => ({
        employeeName: item.employeeName || "N/A",
        primaryDelegate: item.primaryDelegate || "Not Assigned",
        secondaryDelegate: item.secondaryDelegate || "Not Assigned",
        assignedTasks:
          item.assignedTasks?.length > 0
            ? item.assignedTasks
            : "No Tasks Assigned",
      }));

      setDor(mappedData);
    } catch (error) {
      console.error("Unable to fetch Data", error);
    }
  };

  const dashboardData = `
query HRDashboard($userId: ID!) {
  totalLeaveConfigurations
  approvedLeavesWithoutLop(userId: $userId)
  approvedLeavesWithLop(userId: $userId)
  pendingLeavesCount(userId: $userId)
  attendanceDetails {
    checkIn
    checkOut
    firstName
    department
  }
  attendanceCount
  birthdayUsers {
    firstName
    department
  }
  pendingRequestsCount {
    pendingLeaveCount
    pendingWfhCount
    pendingRegularizationCount
  }
  employeeTypeCount {
    typeName
    count
  }
  departmentCount {
    departmentName
    count
  }
}
`;

  const handeldatas = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: dashboardData,
          variables: {
            userId: parsedData?.id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data;
      setData(data);
      const temps = [];

      data?.attendanceDetails.map((item) => {
        if (item?.firstName !== "") {
          temps.push(item);
        }
      });

      setEmployeeLeave(temps);
      setEmployeCount(data?.attendanceCount);
      setbirthday(data?.birthdayUsers);
      const temp = [];
      data?.employeeTypeCount.map((item, ind) => {
        temp.push({
          id: ind + 1,
          value: item?.count,
          label: item?.typeName,
        });
      });
      const lable = [];
      const value = [];
      data?.departmentCount?.map((item) => lable?.push(item?.departmentName));
      data?.departmentCount?.map((item) => value?.push(item?.count));
      setdepart({
        value: value,
        label: lable,
      });
      setCount(temp);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const filteredLabels = [];
  const filteredData = [];
  const backgroundColors = [];
  const hoverBackgroundColors = [];

  leaveCount?.map((item, index) => {
    if (
      item?.leaveType !== "loss_of_pay" &&
      item?.leaveType !== "paternity_leave" &&
      item?.leaveType !== "maternity_leave" &&
      item?.leaveType !== "work_from_home"
    ) {
      filteredLabels.push(
        item?.leaveType == "restricted_holiday"
          ? "Restricted Holiday"
          : item?.leaveType == "casual_leave"
          ? "Casual Leave"
          : item?.leaveType == "earned_leave"
          ? "Earned Leave"
          : item?.leaveType == "sick_leave"
          ? "Sick Leave"
          : item?.leaveType
      );
      filteredData.push(item?.remaining);
      backgroundColors.push(
        ["#FF6384", "#36A2EB", "#FFCE56", "#36ba45"][index % 4]
      );
      hoverBackgroundColors.push(
        ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"][index % 4]
      );
    }
  });
  const pieData = {
    labels: filteredLabels,
    datasets: [
      {
        label: "Leave Details",
        data: filteredData,
        backgroundColor: backgroundColors,
        hoverBackgroundColor: hoverBackgroundColors,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "right",
        labels: {
          font: {
            size: 14,
          },
        },
      },
    },
  };

  const rows = [
    { id: 1, lastName: "Snow", firstName: "Jon", age: 35 },
    { id: 2, lastName: "Lannister", firstName: "Cersei", age: 42 },
    { id: 3, lastName: "Lannister", firstName: "Jaime", age: 45 },
    { id: 4, lastName: "Stark", firstName: "Arya", age: 16 },
    { id: 5, lastName: "Targaryen", firstName: "Daenerys", age: null },
    { id: 6, lastName: "Melisandre", firstName: null, age: 150 },
    { id: 7, lastName: "Clifford", firstName: "Ferrara", age: 44 },
    { id: 8, lastName: "Frances", firstName: "Rossini", age: 36 },
    { id: 9, lastName: "Roxie", firstName: "Harvey", age: 65 },
    { id: 41, lastName: "Stark", firstName: "Arya", age: 16 },
    { id: 51, lastName: "Targaryen", firstName: "Daenerys", age: null },
    { id: 61, lastName: "Melisandre", firstName: null, age: 150 },
    { id: 17, lastName: "Clifford", firstName: "Ferrara", age: 44 },
    { id: 18, lastName: "Frances", firstName: "Rossini", age: 36 },
    { id: 19, lastName: "Roxie", firstName: "Harvey", age: 65 },
  ];

  const newBoxShadow = "0 6px 30px rgba(182, 186, 203, 0.3)";

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
  );

  const leaveCountByUser = `
  query leavedetailbyme($id:String!){
  leaveDetailsByMe(id: $id){
    user{
      email
    }
    status
    takedLeave
    leaveType {
      id
      name
    }
    leaveCount
    workFromHome
  }
}
  `;
  const leavecount = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    const encodedId = btoa(parsedData?.id);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: leaveCountByUser,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data.data.leaveDetailsByMe;

      let filterdata = data.filter(
        (val) => val.leaveType.name !== "loss_of_pay"
      );

      const remainingLeaves = filterdata.map((item) => ({
        leaveType: item.leaveType.name,
        remaining: item.leaveCount - item.takedLeave,
      }));
      setLeaveCount(remainingLeaves);

      // setbirthday(data?.birthdayUsers);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };
  const getLatestAttendanceData = (data) => {
    const latestData = {};
    data?.forEach((item) => {
      const date = new Date(item.checkIn || item.checkOut)
        .toISOString()
        .slice(0, 10);
      if (
        !latestData[date] ||
        new Date(item.lastUpdate) > new Date(latestData[date].lastUpdate)
      ) {
        latestData[date] = item;
      }
    });
    return Object.values(latestData);
  };
  const filteredAttendanceData = getLatestAttendanceData(attendanceData).filter(
    (item) => {
      const date = new Date(item.checkIn);
      return (
        date.getFullYear() === parseInt(selectedYear) &&
        date.getMonth() + 1 === parseInt(selectedMonth) &&
        item.checkIn &&
        !item.checkOut // Only include entries with checkIn but no checkOut
      );
    }
  );
  const attendanceQuery = `
  query userAttendanceDetails($id: String!) {
    userAttendanceDetails(id: $id) {
      data{
      id
      checkIn
      checkOut
      totalWorkingHours
      }
    	error
      message
    }
  }
`;

  const fetchAttendanceData = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    const encodedId = btoa(parsedData?.id);

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: attendanceQuery,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setAttendanceData(response.data?.data?.userAttendanceDetails?.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  return (
    <DashboardLayout isCheckedIn={isCheckedIn}>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {birthpopup && (
        <Dialog
          maxWidth="sm"
          fullWidth
          // {...rest}
          open={true}
        >
          <DialogTitle>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                color: "#6a1b9a",
                fontSize: "0.95rem",
              }}
            >
              Birthday Celebrations For Today🎉
            </Typography>
          </DialogTitle>

          <DialogContent variant="body2">
            {birthday.map((person, index) => (
              <Box
                key={index}
                sx={{
                  marginBottom: 1,
                  padding: 1,
                  borderRadius: 1,
                  backgroundColor: index % 2 === 0 ? "#f3e5f5" : "#ede7f6",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    color: "#6a1b9a",
                    fontSize: "0.95rem",
                  }}
                >
                  {person.firstName}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "0.85rem" }}
                >
                  {person.department}
                </Typography>
              </Box>
            ))}
          </DialogContent>

          <DialogActions>
            <MaterialButton
              color="error"
              variant="text"
              onClick={() => setBirthdayPopup(false)}
            >
              Cancel
            </MaterialButton>
          </DialogActions>
        </Dialog>
      )}
      <Box sx={{ padding: 1, zIndex: 1 }}>
        <Grid2 container spacing={2}>
          {/* Mark Attendance Card */}

          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 2,
                padding: 0.5,
                height: 269,
              }}
            >
              <CardContent>
                {/* Title */}
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: "bold", marginBottom: 2 }}
                >
                  Mark Attendance
                </Typography>

                {/* Timer Section */}
                <Box
                  sx={{
                    backgroundColor: "#fff5ec",
                    borderRadius: 2,
                    padding: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box>
                    <Typography sx={{ color: "#4d5154", fontSize: "15px" }}>
                      Working Hours
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#373b3e",
                        fontSize: "20px",
                      }}
                    >
                      {ischeckIn ? displayTime : "00:00:00"}
                    </Typography>
                  </Box>
                  <Button
                    variant="gradient"
                    sx={{
                      backgroundColor: ischeckIn ? "#fc133d" : "#ffa726",
                      color: "#fff",
                      fontWeight: "bold",
                      marginTop: "20px",
                      marginLeft: "5px",
                    }}
                    onClick={ischeckIn ? handleAddEmployee : handleCheckIn}
                  >
                    {ischeckIn ? "Clock-Out" : "Clock-In"}
                  </Button>
                </Box>
                {ischeckIn ? (
                  <Typography
                    sx={{
                      color: "#4d5154",
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                  >
                    {/* Clock In: {moment(checkInTime).format("hh:mm A")} */}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "#4d5154",
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                  >
                    Last Clock Out: {moment(checkOutTime).format("hh:mm A")}
                  </Typography>
                )}

                <Box sx={{ borderBottom: "1px solid #d3d3d4" }}></Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#373b3e",
                    cursor: "pointer",
                    fontWeight: "500",
                    marginTop: "5%",
                    "&:hover": {
                      color: "#3F51B5d4",
                    },
                  }}
                  onClick={() => navigate("/calendar")}
                >
                  View Attendance
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                boxShadow: newBoxShadow,
                padding: 1,
                minHeight: 270,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: "bold", fontSize: "1rem" }}
                >
                  Attendance & Leaves
                </Typography>
                <Grid container spacing={1.8}>
                  {[
                    {
                      title: "Total Leaves",
                      value: totalLeaveCount,
                      color: "#ff902f",
                    },
                    {
                      title: "Leaves Taken",
                      value: dates?.approvedLeavesWithoutLop,
                      color: "#fc6075",
                    },
                    // { title: "Leaves Absent", value: 6.5, color: "#36ba45" },
                    {
                      title: "Pending Approval",
                      value: dates?.pendingLeavesCount,
                      color: "#9368e9",
                    },
                    // { title: "Working Days", value: 6.5, color: "#009efb" },
                    {
                      title: "Loss of Pay",
                      value: dates?.approvedLeavesWithLop,
                      color: "#fc133d",
                    },
                  ].map((stat, index) => (
                    <Grid item xs={4} sm={4} key={index}>
                      <Typography
                        variant="h5"
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          color: stat.color,
                          mb: 0.25,
                        }}
                      >
                        {stat.value}
                      </Typography>
                      <Typography
                        variant="body2"
                        align="center"
                        sx={{
                          fontSize: "14px",
                          color: "#4d5154",
                          fontWeight: 500,
                        }}
                      >
                        {stat.title}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>

                <Box
                  sx={{
                    borderBottom: "1px solid #d3d3d4",
                    my: 1,
                    marginTop: "19px",
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: "#373b3e",
                    cursor: "pointer",
                    fontWeight: "500",
                    marginTop: "3%",
                    "&:hover": {
                      color: "#3F51B5d4",
                    },
                  }}
                  onClick={() =>
                    navigate("/appyleave/apply-leaverequest")
                  }
                >
                  Apply Leaves
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{ borderRadius: 2, backgroundColor: "#fff", height: 570 }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: 0,
                    padding: 1,
                    fontSize: "1rem",
                  }}
                >
                  Employee's Attendance
                </Typography>
              </CardContent>
              <TableContainer>
                <Table style={{ margin: "0px" }}>
                  {/* Table Head */}
                  <TableHead
                    sx={{
                      height: "427px",
                      paddingLeft: "30px",
                      marginTop: "-16px",
                    }}
                  >
                    <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#0d47a1",
                          fontSize: "0.875rem",
                        }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#0d47a1",
                          fontSize: "0.875rem",
                        }}
                      >
                        Department
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#0d47a1",
                          fontSize: "0.875rem",
                        }}
                      >
                        Check In
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#0d47a1",
                          fontSize: "0.875rem",
                        }}
                      >
                        Check Out
                      </TableCell>
                    </TableRow>

                    {/* Table Body */}
                    <TableBody>
                      {employeeLeave
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row.firstName}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row.department}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {moment(row?.checkIn).format("hh:mm A")}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row?.checkOut
                                ? moment(row?.checkOut).format("hh:mm A")
                                : "Pending"}
                            </TableCell>
                          </TableRow>
                        ))}
                      {/* Handle Empty Data */}
                      {rows?.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No Data Available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </TableHead>
                </Table>
              </TableContainer>

              {/* Pagination at Bottom */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "8px 16px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <TablePagination
                  rowsPerPageOptions={[10]} // Allow 10 rows per page
                  component="div"
                  count={employeeLeave?.length || 0} // Total number of rows
                  rowsPerPage={rowsPerPage} // This state should be set to 10
                  page={page} // Current page state
                  onPageChange={handleChangePage} // Function to handle page change
                  onRowsPerPageChange={handleChangeRowsPerPage} // Function to handle rows per page change
                  ActionsComponent={({
                    count,
                    page,
                    rowsPerPage,
                    onPageChange,
                  }) => (
                    <Box sx={{ flexShrink: 0 }}>
                      <IconButton
                        onClick={(event) => onPageChange(event, page - 1)}
                        disabled={page === 0}
                      >
                        <ChevronLeft />
                      </IconButton>
                      <IconButton
                        onClick={(event) => onPageChange(event, page + 1)}
                        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                      >
                        <ChevronRight />
                      </IconButton>
                    </Box>
                  )}
                />
              </Box>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <div
              style={{
                display: "flex",
              }}
            >
              <Card
                elevation={5}
                sx={{
                  borderRadius: 2,
                  padding: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#ffffff", // Plain white background
                  boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
                  height: 290,
                }}
              >
                {/* Title */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#495057",
                    marginBottom: 2,
                    textAlign: "center",
                  }}
                >
                  Employees Present
                </Typography>

                {/* Count */}
                <Box
                  sx={{
                    backgroundColor: "#f8f9fa",
                    padding: 0,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100px",
                    height: "100px",
                    boxShadow: "0 3px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "40px",
                      fontWeight: "bold",
                      color: "#28a745",
                    }}
                  >
                    {employeCount}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontSize: "0.85rem",
                    // fontStyle: "italic",
                    opacity: 0.8,
                    textAlign: "center",
                    // padding:0.5
                    marginTop: 1,
                  }}
                >
                  Attendance count for today
                </Typography>
              </Card>
              <Card
                sx={{
                  borderRadius: 2,
                  boxShadow: "0 3px 8px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#f9f4ff",
                  padding: 1,
                  height: 250,
                  marginLeft: 2,
                  height: 290,
                  // Adjusted height for a more compact look
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 2,
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 40,
                        height: 40,
                        marginRight: 1,
                        backgroundColor: "#8e44ad",
                        color: "#fff",
                        fontSize: "1.2rem", // Smaller font size for the emoji
                      }}
                    >
                      🎂
                    </Avatar>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "600",
                        color: "#4a148c",
                        fontSize: "18px", // Slightly smaller title font
                      }}
                    >
                      Today’s Birthdays
                    </Typography>
                  </Box>
                  {/* {birthday.map((person, index) => ( */}
                  {birthday?.length == 1 ? (
                    <Box
                      // key={}
                      sx={{
                        marginBottom: 1,
                        padding: 1,
                        borderRadius: 1,
                        backgroundColor: "#ede7f6",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "bold",
                          color: "#6a1b9a",
                          fontSize: "0.95rem",
                        }}
                      >
                        {birthday?.[0]?.firstName}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "0.85rem" }}
                      >
                        {birthday?.[0]?.department}
                      </Typography>
                    </Box>
                  ) : birthday?.length > 1 ? (
                    <>
                      <Box
                        // key={}
                        sx={{
                          marginBottom: 1,
                          padding: 1,
                          borderRadius: 1,
                          backgroundColor: "#ede7f6",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            color: "#6a1b9a",
                            fontSize: "0.95rem",
                          }}
                        >
                          {birthday?.[0]?.firstName}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontSize: "0.85rem" }}
                        >
                          {birthday?.[0]?.department}
                        </Typography>
                      </Box>
                      <Box
                        // key={}
                        sx={{
                          marginBottom: 1,
                          padding: 1,
                          borderRadius: 1,
                          backgroundColor: "#f3e5f5",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            color: "#6a1b9a",
                            fontSize: "0.95rem",
                          }}
                        >
                          {birthday?.[1]?.firstName}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontSize: "0.85rem" }}
                        >
                          {birthday?.[1]?.department}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <Box
                      // key={}
                      sx={{
                        marginTop: 8,
                        padding: 1,
                        borderRadius: 1,
                        backgroundColor: "#f3e5f5",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "bold",
                          color: "#6a1b9a",
                          fontSize: "0.95rem",
                        }}
                      >
                        No Birthday
                      </Typography>
                    </Box>
                  )}
                  {birthday?.length > 2 && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#373b3e",
                        cursor: "pointer",
                        fontWeight: "500",
                        marginTop: "3%",
                        "&:hover": {
                          color: "#3F51B5d4",
                        },
                      }}
                      onClick={() => {
                        setBirthdayPopup(true);
                      }}
                    >
                      See Birthdays
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </div>
            <Card
              elevation={2}
              sx={{
                borderRadius: 2,
                padding: 1,
                backgroundColor: "#fff",
                boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
                marginTop: "8px",
              }}
            >
              <CardContent>
                {/* Title */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: 1,
                    //   textAlign: "center",
                    fontSize: "1rem",
                  }}
                >
                  Pending Approvals
                </Typography>

                {/* Approval Categories */}
                {[
                  {
                    title: "Leaves",
                    count: dates?.pendingRequestsCount?.pendingLeaveCount,
                    color: "#007bff",
                    navigates: "/appyleave",
                  },
                  {
                    title: "WFH",
                    count: dates?.pendingRequestsCount?.pendingWfhCount,
                    color: "#28a745",
                    navigates: "/wfh-management",
                  },
                  {
                    title: "Regularization",
                    count:
                      dates?.pendingRequestsCount?.pendingRegularizationCount,
                    color: "#ffc107",
                    navigates: "/regularization-request",
                  },
                ].map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 1,
                      padding: "4px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: 1,
                    }}
                  >
                    {/* Category Info */}
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "0.85rem",
                          fontWeight: "bold",
                          color: "#4d5154",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: "bold",
                          color: item.color,
                        }}
                      >
                        {item.count}
                      </Typography>
                    </Box>

                    {/* Action Button */}
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: item.color,
                        color: "#fff",
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        paddingX: 1.5,
                        paddingY: 0.5,
                        borderRadius: 2,
                        fontSize: "0.75rem",
                        "&:hover": {
                          backgroundColor: item.color,
                          opacity: 0.9,
                        },
                      }}
                      onClick={() => navigate(item?.navigates)}
                    >
                      Action
                    </Button>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                // border: "1px solid #d5dbdb",
                boxShadow: newBoxShadow,
                padding: 1,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: "bold" }}
                >
                  Available Leave & WFH
                </Typography>
                <div style={{ marginTop: "3%" }}>
                  <Doughnut
                    height={"192px"}
                    data={pieData}
                    options={pieOptions}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                boxShadow: newBoxShadow,
                borderRadius: 2,
                padding: 2,
                minHeight: 270,
              }}
            >
              <CardContent>
                {/* Title and Select Boxes Section */}
                <div
                  style={{
                    // display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "56px",
                    // Added space below the title and selects
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Missing Check-Out Days
                  </Typography>
                  <div
                    style={{ display: "flex", gap: "16px", marginTop: "10px" }}
                  >
                    <div>
                      <select
                        value={selectedYear}
                        onChange={handleYearChange}
                        style={{
                          width: "190px",
                          border: "1px solid gray",
                          textAlign: "center",
                          padding: "10px",
                          borderRadius: "5px",
                          color: "#3F51B5d4",
                          paddingRight: "3px",
                          outline: "none",
                          overflow: "scroll",
                        }}
                      >
                        {Array.from({ length: 12 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option
                              key={year}
                              value={year}
                              style={{ overflow: "scroll" }}
                            >
                              {year}
                            </option>
                          );
                        })}
                      </select>
                      <select
                        style={{
                          width: "190px",
                          border: "1px solid gray",
                          textAlign: "center",
                          padding: "10px",
                          borderRadius: "5px",
                          color: "#3F51B5d4",
                          marginLeft: "6px",
                          outline: "none",
                        }}
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        // className="border rounded p-2"
                      >
                        {Array.from({ length: 12 }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {new Date(0, i).toLocaleString("default", {
                              month: "long",
                            })}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {filteredAttendanceData.length > 0 ? (
                    <div>
                      {filteredAttendanceData.map((entry, index) => (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <MiniCard>
                            Date: {new Date(entry.checkIn).toLocaleDateString()}
                          </MiniCard>

                          <MiniCard>
                            Check In:{" "}
                            {entry.checkIn
                              ? new Date(entry.checkIn).toLocaleTimeString()
                              : "N/A"}
                          </MiniCard>
                          <MiniCard>
                            Check Out:{" "}
                            {entry.checkOut
                              ? new Date(entry.checkOut).toLocaleTimeString()
                              : "N/A"}
                          </MiniCard>
                          {/* </Typography> */}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        marginTop: "20px",
                        color: "#373b3e",
                      }}
                    >
                      No attendance data found without checkout for the selected
                      Data.
                    </Typography>
                  )}
                </div>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                boxShadow: newBoxShadow,
                padding: 1,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: 0,
                    padding: 1,
                    fontSize: "1rem",
                  }}
                >
                  DOR
                </Typography>
              </CardContent>
              <TableContainer>
                <Table>
                  <TableHead
                    sx={{
                      height: "427px",
                      paddingLeft: "30px",
                      marginTop: "-16px",
                    }}
                  >
                    <TableRow sx={{ backgroundColor: "#def6e3" }}>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#28a745",
                          fontSize: "0.875rem",
                        }}
                      >
                        Employee
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#28a745",
                          fontSize: "0.875rem",
                        }}
                      >
                        Primary DOR
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#28a745",
                          fontSize: "0.875rem",
                        }}
                      >
                        Secondary DOR
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#28a745",
                          fontSize: "0.875rem",
                        }}
                      >
                        Task
                      </TableCell>
                    </TableRow>
                    <TableBody>
                      {dor
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row.employeeName}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row.primaryDelegate}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {(row?.secondaryDelegate) || "N/A"}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row?.assignedTasks
                                ? (row?.assignedTasks)
                                : "N/A"}
                            </TableCell>
                          </TableRow>
                        ))}
                      {/* Handle Empty Data */}
                      {dor?.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No Data Available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </TableHead>
                </Table>
              </TableContainer>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "8px 16px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <TablePagination
                  rowsPerPageOptions={[10]}
                  component="div"
                  count={dor?.length || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={({
                    count,
                    page,
                    rowsPerPage,
                    onPageChange,
                  }) => (
                    <Box sx={{ flexShrink: 0 }}>
                      <IconButton
                        onClick={(event) => onPageChange(event, page - 1)}
                        disabled={page === 0}
                      >
                        <ChevronLeft />
                      </IconButton>
                      <IconButton
                        onClick={(event) => onPageChange(event, page + 1)}
                        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                      >
                        <ChevronRight />
                      </IconButton>
                    </Box>
                  )}
                />
              </Box>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            {/* <ReportsAnalytics/> */}
          </Grid2>
        </Grid2>
      </Box>
    </DashboardLayout>
  );
};

export default HRdashboard;
